import * as React from 'react';
import * as main from "../../main.module.scss";
import * as wait from "./style.module.scss";
export const Wait = () => {
  return (
    <section className={wait.wait}>
      <div className="container">
        <div className={wait.container}>
          <h2 className={main.title}>На мастер-классе вас ждёт:</h2>
          <ul className={wait.mainList}>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/mk-01.png" alt=""/>
              <h3>Практика языка без зубрежки</h3>
              <ul>
                <li>Транскрип&shy;ционные знаки и фонетика без усилий</li>
                <li>Грамматика и самый лёгкий способ её учить</li>
                <li>Долгосрочное запоминание слов со скоростью 100 слов в час</li>
              </ul>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/mk-02.png" alt=""/>
              <h3>Мифы и ошибки</h3>
              <ul>
                <li>Почему вы всё ещё не заговорили на английском</li>
                <li>Что считается полезным, но на деле мешает учить язык</li>
              </ul>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/mk-03.png" alt=""/>
              <h3>Заряд мотивации</h3>
              <p><strong>Лучшая мотивация — это ваши успехи!</strong></p>
              <p>Уже на мастер-классе вы поймете, что способны выучить английский без сверхусилий на своем опыте, даже если раньше никогда его не учили</p>
            </li>
          </ul>
          <p className={wait.undertext}>Узнаете, как помогает правильное целеполагание и как усилить этот эффект</p>
        </div>
      </div>
    </section>
  )
};
